import EventDispatcher from "./EventDispatcher";

const Mobile = "mobile";
const Tablet = "tablet";
const Desktop = "desktop";

class Breakpoint {
    constructor() {
        this.tabletMediaQuery = window.matchMedia("screen and (min-width: 620px)");
        this.tabletMediaQuery.addListener(ev => this.onBreakpointStateChange(ev));
        
        this.desktopMediaQuery = window.matchMedia("screen and (min-width: 920px)");
        this.desktopMediaQuery.addListener(ev => this.onBreakpointStateChange(ev));
        
        this.lastBreakpoint = this.getCurrentBreakpoint();
        this.onChange = new EventDispatcher();
    }
    
    get mobile() {
        return Mobile;
    }
    
    get tablet() {
        return Tablet;
    }
    
    get desktop() {
        return Desktop;
    }
    
    getCurrentBreakpoint() {
        let newBreakpoint = this.mobile;
        
        if (this.tabletMediaQuery.matches) {
            newBreakpoint = this.tablet;
        }
        
        if (this.desktopMediaQuery.matches) {
            newBreakpoint = this.desktop;
        }
        
        return newBreakpoint;
    }
    
    onBreakpointStateChange(ev) {
        let newBreakpoint = this.getCurrentBreakpoint();
        
        this.onChange.invokeListeners([newBreakpoint, this.lastBreakpoint], this);
        
        this.lastBreakpoint = newBreakpoint;
    }
}

export default new Breakpoint;